import { Toaster as SonnerToaster } from "sonner";

export function Toaster(props) {
  return (
    <SonnerToaster
      position="top-center"
      richColors
      toastOptions={{
        className:
          "rounded-2xl border border-border/60 bg-background text-foreground shadow-card",
      }}
      {...props}
    />
  );
}

